<template lang="pug">
  v-card.cardPowerBall 
    v-row(align="center")
      v-col(cols="auto" align="center").pr-0
        v-img(:src="src").imgCardPowerBall
        h5.white--text.font-weight-power-ball(
          style="font-size: min(3vw, 15px)"
        ) {{ $t('jackpot-reward') }}
      v-col(align="center").pl-0
        h1.white--text.ml-1.single-line.textJackpot(v-if="items[8]") {{ itemReward(items[8], 1) | number_comma }} {{ $t('unit.baht') }}
    hr.diviverCardReward
    v-row(
      no-gutters
      align="center"
    ).py-3
      v-col(cols=3) 
        .font-weight-power-ball(
          style="font-size: min(2vw,15px) !important; color:white;"
        ) {{ $t('win-number-format') }}
      v-col(align="center") 
        .font-weight-power-ball(
          style="font-size: min(2vw,15px) !important; color:white;"
        ) {{ $t('price') }}
      v-col(v-for="i in powerPlays" :key="i" align="center")
        div(style="font-size:min(1vw,7px)").white--text.font-weight-power-ball Power Play 
        .font-weight-power-ball(
          style="font-size: min(2vw,15px) !important; color:white;"
        ) x{{ i }}

    v-row(
      v-for="(itemR, iR) in itemsReward" 
      :key="iR"
      no-gutters
      align="center"
    )
      v-col(cols=3)
        div(:style="{ width: `${widthPerBall*(itemR.ball )}px` }")
          v-img(:src="itemR.src")
      v-col(v-if="items.length !== 0" align="center")
        h6.white--text {{ items[itemR.index]['reward'] | currency_unit}}
      v-col(v-for="i in powerPlays" :key="i" align="center")
        h6.white--text {{ itemReward(items[itemR.index], i)  | currency_unit}}
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    text:{
      type: String,
      default:null
    }
  },
  data: () => ({
    powerPlays: [2,3,4,5,10],
    itemsReward: [
      { src:require('@/assets/powerball/reward-9.svg'), index:8, ball: 6 },
      { src:require('@/assets/powerball/reward-8.svg'), index:7, ball: 5 },
      { src:require('@/assets/powerball/reward-7.svg'), index:6, ball: 5 },
      { src:require('@/assets/powerball/reward-6.svg'), index:5, ball: 4 },
      { src:require('@/assets/powerball/reward-5.svg'), index:4, ball: 4 },
      { src:require('@/assets/powerball/reward-4.svg'), index:3, ball: 3 },
      { src:require('@/assets/powerball/reward-3.svg'), index:2, ball: 3 },
      { src:require('@/assets/powerball/reward-2.svg'), index:1, ball: 2 },
      { src:require('@/assets/powerball/reward-1.svg'), index:0, ball: 1 },
    ]
  }),
  computed: {
    widthPerBall () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 8
        case 'sm': return 16
        case 'md': return 18
        case 'lg': return 16
        case 'xl': return 20
      }
      return 8
    },
    src () {
      return require('@/assets/powerball/icon_jackpot.svg')
    }
  },
  methods: {
    itemReward (item,i) { 
      if(!item) return
      //Winnumber bonus
      if(item['white_ball']===5 && item['power_ball']===1) {
        return item.reward
      }
      // //Winnumber Second
      // if(item['white_ball']===5 && item['power_ball']===0) {
      //   return item.reward * 2
      // }
      return item.reward * i
    }
  }
}
</script>
<style scoped>
@media only screen and (max-width: 540px) { 
  .imgCardPowerBall {
    max-width: min(8vw, 30px) !important;
  }
  .textJackpot {
    font-size: min(7vw, 30px) !important; 
  }
}
@media only screen and (max-width: 960px) and (min-width: 541px) { 
  .imgCardPowerBall {
    max-width: 30px !important;
  }
  .textJackpot {
    font-size: 40px !important; 
  }
}
.imgCardPowerBall {
  max-width: 60px;
}
.diviverCardReward {
  color: white;
  border: solid 2px; 
}
.cardPowerBall {
  border-radius: 16px;
  padding: 16px;
  background-image: linear-gradient(180deg, var(--card-power-ball-v2), var(--card-power-ball-2-v2));
} 
.textJackpot {
  font-size: 60px;
  font-weight: 900;
  background: linear-gradient(to top, #C99717 40%, #FFFFFF 50%, #B28510 80%);
  background-size: 100%;
  -webkit-background-clip: text;
  -moz-background-clip: text;
  -webkit-text-fill-color: transparent; 
  -moz-text-fill-color: transparent;
}
</style>